import { FormProvider } from "react-hook-form";

import { AdaptiveModal, Button } from "@luce/ui";

import type { AddPaymentMethodModalProps } from "./add-payment-method.types";
import { CreditCardFields } from "./credit-card-fields";
import { useAddPaymentMethod } from "./use-add-payment-method";

export const AddPaymentMethodModal = ({ open, onClose, onSuccess }: AddPaymentMethodModalProps) => {
  const { form, isSubmitting, onSubmit } = useAddPaymentMethod({ onSuccess });

  // Ignore backdrop/escape/swipe dismissals while a save is in flight so the
  // request isn't orphaned; otherwise closing returns to the landing intact.
  const handleOpenChange = (next: boolean) => {
    if (!next && !isSubmitting) onClose();
  };

  return (
    <AdaptiveModal.Root
      open={open}
      onOpenChange={handleOpenChange}
      dismissible={!isSubmitting}
      dialogSize="md"
    >
      <AdaptiveModal.Header>
        <AdaptiveModal.Title>Add your credit card</AdaptiveModal.Title>
      </AdaptiveModal.Header>

      <AdaptiveModal.Body>
        <FormProvider {...form}>
          <CreditCardFields disabled={isSubmitting} />
        </FormProvider>
      </AdaptiveModal.Body>

      <AdaptiveModal.Footer>
        <AdaptiveModal.Close asChild>
          <Button variant="tertiary" label="Cancel" disabled={isSubmitting} />
        </AdaptiveModal.Close>
        <Button variant="primary" label="Save card" loading={isSubmitting} onClick={onSubmit} />
      </AdaptiveModal.Footer>
    </AdaptiveModal.Root>
  );
};
